import { cn } from '@/shared/lib/cn';

type AvatarSize = 'sm' | 'md' | 'lg';

interface AvatarProps {
  /** Image URL */
  src?: string | null;
  /** User name for fallback initials */
  name: string;
  /** Size preset */
  size?: AvatarSize;
  /** Additional CSS classes */
  className?: string;
}

const SIZE_CLASSES: Record<AvatarSize, string> = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-14 w-14 text-lg',
};

function getInitials(name: string): string {
  return name
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export function Avatar({ src, name, size = 'md', className }: AvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={cn('rounded-full object-cover', SIZE_CLASSES[size], className)}
      />
    );
  }

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full bg-primary-100 font-medium text-primary-700',
        SIZE_CLASSES[size],
        className,
      )}
      role="img"
      aria-label={name}
    >
      {getInitials(name)}
    </div>
  );
}
